import Backbone from 'backbone'
import conductor from 'scoreboard/components/conductor'
import $ from 'jquery'
import _ from 'lodash'
import EmptyState from 'scoreboard/components/empty-state'
import spectator from 'scoreboard/components/spectator'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import metadata from 'scoreboard/components/metadata'
import layoutManager from 'scoreboard/components/layout-manager'
import highlight from 'scoreboard/components/highlight'
import urlValidator from 'scoreboard/components/validators/url-validator'
import gotoBriefing from './goto-briefing.hbs'
import notFound from 'scoreboard/components/not-found.hbs'
import notImplemented from 'scoreboard/components/not-implemented.hbs'
import iframeTemplate from 'scoreboard/components/embedded-iframe.hbs'
import displayPaneBody from 'scoreboard/components/display-pane-body.hbs'
import tabs from 'scoreboard/components/view-edit-tabs.hbs'
import SendToOptions from 'scoreboard/components/send-to-options'
import LoadingDots from 'scoreboard/components/loading-dots'
import { EMBEDDED_URL_LOAD_DELAY } from 'scoreboard/components/export/send-to-export'
import globals from 'scoreboard/components/globals'
import slideControls from './briefer'
import DisplayHeader from 'scoreboard/components/display-header'


/**
 * Need a dedicated view for this so that the iFrame's load event can be
 * observed and in turn trigger the 'ready' for exports.
 */
const IFrameSlide = Backbone.View.extend({

	className: 'display-layout table-hack external-slide-overview',

	deferredReady: true,

	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		const {url} = this.options
		var iframe
		// If we're displaying an export, just show the iframe and the slide header
		if (layoutManager.export) {
			/* #50962 uncomment this once iframe export is fixed
			iframe = $(iframeTemplate({
				attributes: `src="${url}" height="100%" width="100%" frameborder="0"`
			}))
			*/

			// #50962 remove this once iframe export is fixed
			iframe = $('<div>')

			const { slideNumberText, label } = slideControls.getSlideInfo()
			// We will manually add a header for exports
			this.$el.replaceWith(iframe)
			let headerHtml =
				'<div class="export-slide-info web-slide">' +
				`${label}<span class="pre-label">${slideNumberText}</span>` +
				'</div>'
			iframe.before(headerHtml)

			// #50962 remove this once iframe export is fixed
			this.trigger('ready')
			return this
		// If we're displaying this inside the app, give it a real header/body like other views
		} else {
			iframe = $(iframeTemplate({
				attributes: `src="${url}" frameborder="0"`
			// once the external webside loads, nix loading dots
			})).on('load', () => this.loadingDots.clear())

			var section = conductor.section(this.model.get('url'))
			var header = new DisplayHeader({
				model: this.model,
				subsection: 'overview',
				tabs: tabs({
					id: this.model.id,
					section: this.model.section,
					overviewTabCode: 'common.view',
					urlOverride: spectator.getCurrentUrl()
 				}),
				sendToOptions: SendToOptions.default({section: 'briefings'})
			})
			this.$el.append(header.el)
			header.render()

			var body = $(displayPaneBody())
			body.find('.scroll-container').replaceWith(iframe)
			this.$el.append(body)
			// Show loading dots over the iframe while the external website loads
			this.loadingDots = new LoadingDots()
			this.$('.display-pane-body .table-hack-cell').append(this.loadingDots.el)
			this.loadingDots.render()
		}

		iframe.on('load', jq => {
			// https://github.com/SpiderStrategies/Scoreboard/issues/28362#issuecomment-583000822
			console.log('Waiting', EMBEDDED_URL_LOAD_DELAY, 'milliseconds to capture iframe for export.')
			setTimeout(() => this.trigger('ready'), EMBEDDED_URL_LOAD_DELAY)
		})

		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.loadingDots], 'remove')
	}
})

var BriefingsOverview = Backbone.View.extend({
	// this.model is the current Briefing

	// Exports need to respond to the ready event of the slide view, not this view
	// used by app-display.js#setView
	deferredReady: true,

	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		const id = this.model.id
		const slideId = this.options.slideId || _.result(this.model.get('slides'), '[0].id')
		var slide = this.model.slides().get(slideId)

		if (conductor.section() === 'bookmarks') {
			const message = i18n.get('briefingBooks.onlyViewableInBBSection', highlight(i18n.get('briefingBooks.briefingBooks')))
			let emptyStateMessage = new EmptyState({
				body: gotoBriefing({id, slideId, message})
			})
			appDisplay.display(emptyStateMessage)

			emptyStateMessage.$('.goto-briefing').click(() => {
				// Set the global orgId to null. This is done so that, when the briefings router
				// is loaded after the below navigationToSpectated, it knows to update the
				// orgId and projectId based on the newly shown briefing.
				// globals.orId will be set again in base-router.js:load()
				// https://github.com/SpiderStrategies/Scoreboard/issues/30080
				globals.orgId = null
				conductor.navigateToSpectated(`briefings/${id}/slides/${slideId}`, this.model)
			})
		} else if (slide) {
			// If we're dealing with an external url slide, add an extra url
			// field to be used while creating the tabs
			if (spectator.isCurrentExternalUrl()) {
				spectator.setCurrent(_.extend({}, slide, {
					url: spectator.buildSpectatedUrl(slide)
				}))
			} else {
				spectator.setCurrent(slide)
			}

			var url = slide.getStatefulUrl({
				queryString: window.location.search,
				routeSuffix: getRouteSuffix(slide.get('url'))
			})

			if (url) {
				// load the URL without changing the URL for the browser
				var foundRoute = Backbone.history.loadUrl(url,
						{ preventWelcomeRedirect: true })

				if (!foundRoute) {
					if (!urlValidator(url)) {
						appDisplay.display(new IFrameSlide({ url, model: this.model }))
					} else {
						var notImplementedView = new EmptyState({
							body: notImplemented(metadata.briefings)
						})
						appDisplay.display(notImplementedView)
					}
				}

				// make sure the correct URL is displayed.  This is important
				// in case the URL only had a briefing ID in it and no slide ID
				// and we went ahead and added the slide ID
				conductor.navigate('briefings/' + id + '/slides/' + slideId, { replace: true })
			}
		} else {
			$('.nav-display-pane').addClass('item-not-found')
			appDisplay.display(new EmptyState({
				body: notFound()
			}))
		}

		return this
	}
})

function getRouteSuffix(url) {
	var routesWithExport = ['scorecards/','initiatives/']
	var exportable = _.some(routesWithExport, r => _.includes(url, r))
	let suffix
	if (layoutManager.export && exportable) {
		suffix = '/export'
	}
	return suffix
}

export default BriefingsOverview

BriefingsOverview.__filename__ = 'briefings/briefings-overview.js'
